import { createSlice } from '@reduxjs/toolkit';
import { createAsyncThunkWithLoggingAndRetry } from '../store/middleware/thunk_helper';
import { CASE_SEARCH_SUCCESS, CASE_GET_BY_CASE_ID_SUCCESS } from '../actions/actionTypes';
import {
  getPatientByCaseId as getPatientByCaseIdService,
  getFullPatientForMyUser as getFullPatientForMyUserService,
} from '../services/patientService';

export function getPatientById({ patientId }) {
  return function (dispatch, getState) {
    const state = getState();
    const findCaseIdForPatient = (state, patientId) => {
      const cases = state.entities.cases;
      if (!cases) return null;
      const caseIds = Object.keys(cases);
      for (const caseId of caseIds) {
        if (cases[caseId].patientId === patientId) {
          return caseId;
        }
      }
      return null;
    };
    const caseId = findCaseIdForPatient(state, patientId);
    if (caseId) {
      return dispatch(getPatientByCaseId({ caseId }));
    } else {
      // console.warn(`Could not find case for patient ${patientId}`);
      // return Promise.reject(new Error(`Could not find case for patient ${patientId}`));

      // should never get here but
      // if we dont have the case then it probably doesnt matter
      return Promise.resolve();
    }
  };
}

export const getPatientByCaseId = createAsyncThunkWithLoggingAndRetry(
  'patient/getByCaseId',
  ({ caseId }, { rejectWithValue }) => {
    return getPatientByCaseIdService(caseId);
  },
  { retry: true }
);
export const getFullPatientForMyUser = createAsyncThunkWithLoggingAndRetry(
  'patient/getFullPatientForMyUser',
  () => {
    return getFullPatientForMyUserService();
  },
  { retry: true }
);

const INITIAL_STATE = {};
const patientsSlice = createSlice({
  name: 'patients',
  initialState: INITIAL_STATE,
  reducers: {},
  extraReducers: (builder) => {
    builder
      // this is weird - used to poulate the summary screen for squad, which
      // is refreshed every time the screen is visited anyway - probably no need to store patients
      // in persisted redux here (but neet to look closer)
      // the search for case/patient data is incomplete, which is why its overwriting
      // search results with any patient data already in redux
      .addCase(CASE_SEARCH_SUCCESS, (state, action) => {
        return {
          ...action.payload?.entities?.patients,
          ...state,
        };
      })
      // can probably normalize the result of this to match default case
      .addCase(CASE_GET_BY_CASE_ID_SUCCESS, (state, action) => {
        return {
          ...state,
          ...action.payload.patient,
        };
      })
      .addDefaultCase((state, action) => {
        if (action.payload?.entities?.patients) {
          return {
            ...state,
            ...action.payload?.entities?.patients,
          };
        }
        return state;
      });
  },
});

export default patientsSlice.reducer;
